export const USER_NAME_SESSION_ATTRIBUTE_NAME = "authenticatedUser";
export const TOKEN_SESSION_ATTRIBUTE_NAME = "token";
export const ROLE_SESSION_ATTRIBUTE_NAME = "role";
export const PROFILE_PREFERENCE = "preference";
export const IS_CC_USER = "isCCUser";
export const headingValues = [
  "heading1",
  "heading2",
  "heading3",
  "heading4",
  "heading5",
  "heading6",
];
export const fontSizeValues = ["5", "10", "15", "20", "25", "30"];
export const fontValues = [
  "Inter",
  "Serif",
  "Cursive",
  "Monospace",
  "Comic Sans",
];
export const STAMP_BORDER = 20;
export const PDFTRON_LICENSE_KEY =
  "SAFEbuilt LLC(safebuilt.com):OEM:PRO Plan Review Optimization::B+:AMS(20220722):4BB588A20467880A7360B13AC9A2537860612FCDFB9B2A25DD149409CD7C0E55D17131F5C7";
export const REVIEWER_NAME_SESSION_ATTRIBUTE_NAME = "reviewerName";
